import { FC } from 'react'

import { Body2, Caption1 } from '@ui/Typography'
import { Link } from '@ui/components/Link'

import { Box } from '@shared/components/Box'
import { IBContestBadgeMap, StatusBadge } from '@shared/components/StatusBadge/StatusBadge'

type DetailsModalRowConfig =
  | { variant: 'text'; label: string | null }
  | { variant: 'date'; date: string; time: string }
  | { variant: 'status'; statusId: number }
  | { variant: 'link'; link: string; onClick: () => void }

interface DetailsModalRowProps {
  label: string
  config: DetailsModalRowConfig
}

export const DetailsModalRow: FC<DetailsModalRowProps> = ({ label, config }) => (
  <Box flex justify='space-between' align='center' fullWidth>
    <Box flexItem='1 0 0'>
      <Body2 color='text-low-em'>{label}</Body2>
    </Box>
    <Box flexItem='1 0 0'>
      <DetailsModalRowValue config={config} />
    </Box>
  </Box>
)

const DetailsModalRowValue: FC<{ config: DetailsModalRowConfig }> = ({ config }) => {
  switch (config.variant) {
    case 'text':
      return <Body2 color='text-high-em'>{config.label}</Body2>
    case 'date':
      return (
        <Box flex direction='column' justify='center' align='flex-start'>
          <Body2 color='text-med-em'>{config.date}</Body2>
          <Caption1 color='text-low-em'>{config.time}</Caption1>
        </Box>
      )
    case 'status':
      return <StatusBadge size='xs' id={config.statusId} badgeMap={IBContestBadgeMap} />
    case 'link':
      return (
        <Link variant='tertiary' onClick={config.onClick}>
          <Body2>{config.link}</Body2>
        </Link>
      )
  }
}
